import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class PNLEditTransactionReportUseCase extends BaseUseCase {
    constructor(pnlReportRepo) {
        super();
        this.pnlReportRepo = pnlReportRepo;
    }
    async fetchResult(requestData) {
        const pnlReportData = await this.pnlReportRepo.sendEditSplitPNLTransactionData(requestData);
        return pnlReportData;
    }
}
export default PNLEditTransactionReportUseCase;
